import React from 'react'
import {
  Create,
  SimpleForm,
  TextInput,
  required
} from 'react-admin'

const GraduateProgramCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="name" validate={[required()]} />
    </SimpleForm>
  </Create>
)

export default GraduateProgramCreate
